<template>
	<div>
		<EditorComp
			v-model="stringContent"
			editorStyle="height: 200px"
			toolbar="#customToolbar"
			@text-change="onTextChange"
		>
			<template #toolbar>
				<div id="customToolbar">
					<div class="inline-flex items-center">
						<span class="ql-formats !mr-0">
							<EwTooltip>
								<template #content>
									<div class="text-center">
									Undo
									<div class="color-gray"><kbd>Ctrl</kbd><kbd>+</kbd><kbd>Z</kbd></div>
									</div>
								</template>
								<button type="button" class="undo-btn" :disabled="!canUndo" title="Undo" @click="undo()">
									<i class="tabler:arrow-back-up flex font-500 !color-[#64748b]"></i>
								</button>
							</EwTooltip>
							<EwTooltip>
								<template #content>
									<div class="text-center">
										Redo
									<div class="color-gray"><kbd>Ctrl</kbd><kbd>+</kbd><kbd>Y</kbd></div>
									</div>
								</template>
								<button type="button" class="redo-btn" :disabled="!canRedo" title="Redo" @click="redo()">
									<i class="tabler:arrow-forward-up flex font-500 !color-[#64748b]"></i>
								</button>
							</EwTooltip>
						</span>

						<EwTooltip>
							<template #content>
								<div class="text-center">
									Bold
								<div class="color-gray"><kbd>Ctrl</kbd><kbd>+</kbd><kbd>B</kbd></div>
								</div>
							</template>
							<button class="ql-bold" @click="commit()" />
						</EwTooltip>
						<EwTooltip>
							<template #content>
								<div class="text-center">
									Italic
								<div class="color-gray"><kbd>Ctrl</kbd><kbd>+</kbd><kbd>I</kbd></div>
								</div>
							</template>
							<button class="ql-italic" @click="commit()" />
						</EwTooltip>
						<EwTooltip>
							<template #content>
								<div class="text-center">
									Underline
								<div class="color-gray"><kbd>Ctrl</kbd><kbd>+</kbd><kbd>U</kbd></div>
								</div>
							</template>
							<button class="ql-underline" @click="commit()" />
						</EwTooltip>
						<EwTooltip text="Bullet List">
							<button class="ql-list" value="bullet" @click="commit()" />
						</EwTooltip>
						<EwTooltip text="Ordered List">
							<button class="ql-list" value="ordered" @click="commit()" />
						</EwTooltip>
						<EwTooltip text="Clear Formating">
							<button class="ql-clean" value="clean" @click="commit()" />
						</EwTooltip>
						<EwTooltip text="SuperScript">
							<button class="ql-script" value="super" @click="commit()"></button>
						</EwTooltip>
						<EwTooltip text="SubScript">
							<button class="ql-script" value="sub" @click="commit()"></button>
						</EwTooltip>
						<EwTooltip text="Source Code">
							<button class="ql-code-block" @click="commit()" />
						</EwTooltip>
					</div>
				</div>
			</template>
		</EditorComp>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useManualRefHistory, useDebounceFn } from '@vueuse/core';
import { EwTooltip } from '@arkit/ew-vue-components';

const content = defineModel<string>('modelValue', { required: true });

const { history, commit, undo, redo, canUndo, canRedo } = useManualRefHistory(content, {
	clone: true,
});

const stringContent = computed({
	get: () => content.value || '',
	set: (val: string) => {
		content.value = val;
	},
});

const onTextChange = useDebounceFn(() => {
	commit();
}, 50);
</script>

<style scoped>

</style>
